export default __webpack_public_path__ + "static/media/unknown.7b351b6c.svg";